import { FC, useEffect } from 'react'
import { useClipboard } from 'use-clipboard-copy'
import IconButton from 'components/atoms/icon-button'
import clsx from 'clsx'

interface ClipboardButtonProps {
	url?: string
	className?: string
	loading?: boolean
	disabled?: boolean
	onCopy?: (...args: any[]) => void
	isCopied?: boolean
	setIsCopied?: (...args: any[]) => void
}

const ClipboardButton: FC<ClipboardButtonProps> = ({
	url,
	className,
	loading,
	disabled,
	onCopy,
	isCopied,
	setIsCopied,
}) => {
	const clipboard = useClipboard({
		copiedTimeout: 2000,
	})

	useEffect(() => {
		if (!clipboard.copied) {
			setIsCopied?.(false)
		}
	}, [clipboard.copied])

	return (
		<IconButton
			icon={clipboard.copied ? 'check' : 'link'}
			onClick={() => {
				if (onCopy) {
					onCopy({ clipboard, url })
				} else {
					clipboard.copy(url)
				}
			}}
			title="Copy this url"
			loading={loading}
			disabled={loading || disabled || isCopied}
			className={clsx(className, {
				'!bg-primary-alt !bg-opacity-50': clipboard.copied,
				'cursor-not-allowed': loading || disabled || isCopied,
			})}
		/>
	)
}

export default ClipboardButton
